import { FormError } from "../models/FormValidation/FormError";
import { FormFieldMeta } from "../models/FormValidation/FormFieldMeta";
import { FormValidateData } from "../models/FormValidation/FormValidateData";

function isValidEmail(search: any) {
    var  serchfind:boolean;

    var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    serchfind = regexp.test(search);
    return serchfind;
}

function isValidPhoneNumber(input:string) 
{
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(input);
}

function isValidVendorPhoneNumber(input:string) 
{
    //var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{5}$/im;
    //var re =  /^94[\+]?[(]?[0-9]{1}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{5}$/im;
    //var re =  /^[0-9]{11}$/im;
    var re =  /^[0-9]{10,15}$/im;
    return re.test(input);
    //return true;
}

function isValidMobileNumberForSms(input:string) 
{
    var re =  /^[1-9][0-9]{9,14}$/im;
    return re.test(input);
}

function isValidPostalCode(input:string) { 
   if(!input || !input.trim()){
     return false;
   }
   // var re =  /^(?:[A-Za-z0-9]{5}|[A-Za-z0-9]{10})$/im;
   var re =  /^(?:[A-Za-z0-9][A-Za-z0-9-\s]{1,8}[A-Za-z0-9])$/im;
    return re.test(input.trim());
}

function validateFields(validateFieldsData: Array<FormFieldMeta>, record:any) { 
    let formValidateData:FormValidateData = {isValid:true, errorsList:[]};
   // var tempArray: Array<FormError> = [];
    let len = validateFieldsData.length;
   // let valid = true;
    let fieldValidity = false;
    for (let index = 0; index < len; index++) {
      var fieldData = validateFieldsData[index];
      fieldValidity = true;
      if (fieldData.isRequired) {
        if (
          !record[fieldData.fieldName] ||
          (fieldData.isList && record[fieldData.fieldName].length === 0)
        ) {
            formValidateData.errorsList.push({
            fieldName: fieldData.fieldName,
            errorMsg: fieldData.reuiredMsg!,
          });
          formValidateData.isValid = false;
          fieldValidity = false;
        }
      }
      if(fieldValidity){
        // check format error    
        if (fieldData.formatFunc){
          if(!fieldData.formatFunc(record[fieldData.fieldName])){
            formValidateData.errorsList.push({
              fieldName: fieldData.fieldName,
              errorMsg: fieldData.formatMsg!,
            });
            formValidateData.isValid = false;
            fieldValidity = false;
          }
        }
      }
    }

    return formValidateData;
}

const getErrorState = (input: string, formErrors:Array<FormError>) => {
  var errIndex = formErrors.findIndex(function (row) {
    return row.fieldName === input && row.errorMsg;
  });
  return errIndex !== -1 ? true : false;
};

export const FormUtil = {
    isValidEmail,
    isValidPhoneNumber,
    isValidVendorPhoneNumber,
    isValidMobileNumberForSms,
    isValidPostalCode,
    validateFields,
    getErrorState
};

